import { TemplatesReducerCreator, TemplatesState } from '../types';
import FetchAllGlobalTemplatesForCategoryFilters from '@/connection/categories/fetch-all-global-template-category-filters';
import { RootState } from '@/store/main';

const fetchAllGlobalTemplatesForCategoriesReducer = (create: TemplatesReducerCreator) => {
  return create.asyncThunk(
    (_, { getState }) => {
      const state = getState() as RootState;
      const templatesSlice = state.templates as TemplatesState;
      if (templatesSlice?.globalTemplatesForCategoryFilters) {
        return templatesSlice.globalTemplatesForCategoryFilters;
      }
      return FetchAllGlobalTemplatesForCategoryFilters();
    },
    {
      fulfilled: (state, action) => {
        state.globalTemplatesForCategoryFilters = action.payload;
      },
      rejected: (_, action) => {
        console.error(action.error);
      },
    }
  );
};

export default fetchAllGlobalTemplatesForCategoriesReducer;
